import { render, staticRenderFns } from "./ViewCase.vue?vue&type=template&id=76bbd240&"
import script from "./ViewCase.vue?vue&type=script&lang=js&"
export * from "./ViewCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports